module.exports = __webpack_public_path__ + "media/img/help_center/Student_Test_08-5a8ce1e86580a90297df4c4d33ed95db.jpg";